import React, { useImperativeHandle, useState, forwardRef } from 'react'

import { Modal, Typography } from 'antd'

export type HelpModalRef = {
  show: () => void
  close: () => void
}

export const HelpModal = forwardRef<HelpModalRef>((_, ref) => {
  const [visible, toggleVisible] = useState(false)

  useImperativeHandle(ref, () => ({
    show: () => toggleVisible(true),
    close: () => toggleVisible(false),
  }))

  const handleClose = () => toggleVisible(false)

  return (
    <Modal
      title="Help"
      open={visible}
      cancelButtonProps={{ style: { visibility: 'hidden' } }}
      onOk={handleClose}
      onCancel={handleClose}
    >
      Email us at
      <Typography.Text strong>
        <a href="mailto: help@subbase.io"> help@subbase.io </a>
      </Typography.Text>
      or call us directly at <Typography.Text strong>954-684-7939</Typography.Text>. Reach out any time with questions,
      issues, or feedback!
    </Modal>
  )
})
